import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VRadioGroup,_vm._b({attrs:{"mandatory":false},model:{value:(_vm.Value),callback:function ($$v) {_vm.Value=$$v},expression:"Value"}},'v-radio-group',_vm.$attrs,false),_vm._l((_vm.radios),function(radio,id){return _c(VRadio,{key:id,attrs:{"color":_vm.$vuetify.theme.currentTheme.primary,"checked":radio.checked,"radios":_vm.radios,"label":radio.label,"value":radio.value}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }